/* ============================================================================
   BKS — P2 : Mousse de guidon assortie (cross-sell color-matched), configurateur 2D.
   ----------------------------------------------------------------------------
   Case OPT-IN (NON pre-cochee — art. 22 directive 2011/83/UE : pas d option payante
   cochee par defaut) « + Mousse de guidon assortie » dans le configurateur 2D.
   A l'ajout panier, ajoute une ligne INDEPENDANTE (SANS _bks_id => ignoree par
   assets/bks-cart-guard.js => detachable) = la mousse de la couleur du DESSUS
   choisi (mapping Liquid window.BKS_MOUSSE), fallback master couleur-au-choix.

   Approche : composant externe (comme bks-cart-guard.js). AUCUNE modif du
   snippet obfusque configurateur-2d.liquid.
     1) injecte la case dans le conteneur .cart du configurateur ;
     2) lit la couleur DESSUS selectionnee dans le DOM (.selname / .sw.sel[title]) ;
     3) intercepte le POST /cart/add.js : si le body contient une ligne
        _bks_role:'base' ET la case cochee, AJOUTE la ligne mousse a items[]
        APRES coup => _bks_parts (deja calcule sur la ligne base) reste inchange
        => le guard compte toujours base+supplements uniquement.

   FAIL-SAFE : toute la logique est en try/catch. Couleur inconnue, mapping
   absent, ou throw quelconque => l'ajout-panier ORIGINAL passe INCHANGE
   (la selle s'ajoute toujours). La case est decochable.

   Le mapping window.BKS_MOUSSE est injecte en Liquid (all_products) par le bloc
   d'inclusion (snippets/configurateur-2d.liquid). Si absent, la case ne s'affiche pas.
   ============================================================================ */
(function () {
  "use strict";
  try {
    if (window.__bksMousse) return; window.__bksMousse = 1;
  } catch (e) { return; }

  // Mapping nom couleur DESSUS (normalise) -> handle mousse.
  // Decision proprio : 'Bleu' -> bleu fonce. Couleurs absentes (Noir, Rouge,
  // Carbone noir/blanc, Noir alcantara) -> fallback master.
  var COLOR_TO_HANDLE = {
    "blanc": "mousse-de-guidon-bks-blanc",
    "gris": "mousse-de-guidon-bks-gris",
    "bleu": "mousse-de-guidon-bks-bleu-fonce",
    "bleu clair": "mousse-de-guidon-bks-bleu-clair",
    "turquoise": "mousse-de-guidon-bks-bleu-turquoise",
    "jaune": "mousse-de-guidon-bks-jaune",
    "orange": "mousse-de-guidon-bks-orange",
    "rose": "mousse-de-guidon-bks-rose",
    "vert": "mousse-de-guidon-bks-vert",
    "violet": "mousse-de-guidon-bks-violet"
  };

  function norm(s) {
    try {
      return (s || "").toLowerCase().normalize("NFD")
        .replace(/[̀-ͯ]/g, "")  // retire les accents
        .replace(/\s+/g, " ").trim();
    } catch (e) { return (s || "").toLowerCase().trim(); }
  }

  function master() {
    return (window.BKS_MOUSSE && window.BKS_MOUSSE.master) || "mousse-de-guidon-bks-couleur-au-choix";
  }

  function root() { return document.querySelector(".bks2d"); }

  // Couleur DESSUS selectionnee : groupe dont le .grp contient "Dessus" -> .selname "— <nom>"
  function selectedDessusColor() {
    try {
      var r = root(); if (!r) return null;
      var grps = r.querySelectorAll(".panel .grp");
      for (var i = 0; i < grps.length; i++) {
        var label = grps[i].textContent || "";
        // "Dessus" mais pas "Dessus de selle" d'un autre groupe : le 1er match suffit ici
        if (/dessus/i.test(label)) {
          var sn = grps[i].querySelector(".selname");
          if (sn && sn.textContent) {
            var t = sn.textContent.replace(/^[\s—\-]+/, "").trim();
            if (t) return t;
          }
          var sws = grps[i].nextElementSibling;
          var sel = sws && sws.querySelector(".sw.sel, .swv.sel");
          if (sel && sel.title) return sel.title;
          return null;
        }
      }
    } catch (e) {}
    return null;
  }

  function mapHandle(colorName) {
    var key = norm(colorName);
    return COLOR_TO_HANDLE[key] || master();
  }

  // {id, price} depuis le mapping Liquid ; fallback master ; null si rien.
  function variantFor(handle) {
    try {
      var by = window.BKS_MOUSSE && window.BKS_MOUSSE.byColor;
      if (!by) return null;
      if (by[handle] && by[handle].id) return by[handle];
      var m = by[master()];
      return (m && m.id) ? m : null;
    } catch (e) { return null; }
  }

  function isMatched(handle) { return handle !== master(); }

  // --- UI : case pre-cochee dans .cart (au-dessus du bouton/total)
  function injectCheckbox() {
    try {
      var r = root(); if (!r) return;
      var cart = r.querySelector(".cart"); if (!cart) return;
      if (cart.querySelector(".bks-mousse")) return; // idempotent

      // Si aucun mapping mousse exploitable, on n'affiche PAS la case (pas de fausse offre).
      if (!variantFor(mapHandle(selectedDessusColor()))) return;

      var wrap = document.createElement("label");
      wrap.className = "bks-mousse";
      wrap.style.cssText = "display:flex;gap:8px;align-items:flex-start;margin:0 0 10px;padding:8px 10px;border:1px solid #8b5cf6;border-radius:8px;font-size:13px;line-height:1.35;cursor:pointer;";
      var cb = document.createElement("input");
      cb.type = "checkbox"; cb.checked = false; cb.className = "bks-mousse-cb";
      cb.style.cssText = "margin-top:2px;flex:0 0 auto;";
      var txt = document.createElement("span");
      txt.className = "bks-mousse-txt";
      wrap.appendChild(cb); wrap.appendChild(txt);
      cart.insertBefore(wrap, cart.firstChild);
      refreshLabel();

      // Re-libelle quand la couleur change (clic sur un swatch).
      r.addEventListener("click", function () { setTimeout(refreshLabel, 0); });
    } catch (e) {}
  }

  function refreshLabel() {
    try {
      var r = root(); if (!r) return;
      var wrap = r.querySelector(".bks-mousse");
      var txt = r.querySelector(".bks-mousse-txt");
      if (!txt) return;
      var color = selectedDessusColor();
      var handle = mapHandle(color);
      var v = variantFor(handle);
      if (!v) { if (wrap) wrap.style.display = "none"; return; }
      if (wrap) wrap.style.display = "flex";
      var price = (typeof v.price === "number")
        ? v.price.toFixed(2).replace(".", ",")
        : String(v.price).replace(".", ",");
      txt.textContent = "+ Mousse de guidon " + (isMatched(handle) ? "assortie" : "BKS") + " (" + price + " €)";
    } catch (e) {}
  }

  function wantMousse() {
    try {
      var r = root(); var cb = r && r.querySelector(".bks-mousse-cb");
      return !!(cb && cb.checked);
    } catch (e) { return false; }
  }

  function isConfiguratorAdd(body) {
    try {
      var items = body && body.items;
      if (!Array.isArray(items)) return false;
      return items.some(function (it) {
        return it && it.properties && it.properties._bks_role === "base";
      });
    } catch (e) { return false; }
  }

  function buildMousseItem() {
    try {
      var color = selectedDessusColor();
      var handle = mapHandle(color);
      var v = variantFor(handle);
      if (!v || !v.id) return null;
      var props = { "_bks_mousse": "1" };           // PAS de _bks_id => guard l'ignore
      // wave8/CROSS-02 : ne poser "Assortie à" que si la couleur est reellement mappee
      // (isMatched). En fallback master "Couleur Au Choix", la mousse n'est PAS assortie :
      // on omet la propriete pour rester coherent avec le libelle "Mousse de guidon BKS".
      if (isMatched(handle) && color) {
        props["Assortie à"] = color;
      }
      return { id: v.id, quantity: 1, properties: props };
    } catch (e) { return null; }
  }

  // --- Interception POST /cart/add.js (le snippet 2D utilise fetch).
  // On ne modifie le body QUE si : URL add, case cochee, et body = add configurateur.
  // Sinon -> passthrough strict. Toute exception -> add original intact.
  try {
    var of = window.fetch;
    if (typeof of === "function") {
      window.fetch = function () {
        var a = arguments;
        try {
          var u = (a[0] && a[0].url) || a[0] || "";
          if (typeof u === "string" && /\/cart\/add(\.js)?(\?|$)/.test(u) &&
              a[1] && typeof a[1].body === "string" && wantMousse()) {
            var body = null;
            try { body = JSON.parse(a[1].body); } catch (e) { body = null; }
            if (body && isConfiguratorAdd(body)) {
              var already = (body.items || []).some(function (it) {
                return it && it.properties && it.properties._bks_mousse;
              });
              if (!already) {
                var m = buildMousseItem();
                if (m) {
                  body.items.push(m);  // _bks_parts deja fige sur la ligne base => guard OK
                  var newInit = {};
                  for (var k in a[1]) { if (Object.prototype.hasOwnProperty.call(a[1], k)) newInit[k] = a[1][k]; }
                  newInit.body = JSON.stringify(body);
                  a = [a[0], newInit];
                }
              }
            }
          }
        } catch (e) { /* fail-safe : on retombe sur l'appel original */ }
        return of.apply(this, a);
      };
    }
  } catch (e) {}

  // --- Init : le snippet remplace .panel apres fetch des options.
  function tryInit() {
    try {
      var r = root();
      if (r && r.querySelector(".cart")) { injectCheckbox(); return true; }
    } catch (e) {}
    return false;
  }
  try {
    if (!tryInit()) {
      var obs = new MutationObserver(function () { if (tryInit()) { try { obs.disconnect(); } catch (e) {} } });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 15000);
    }
  } catch (e) {}
})();
